<template>
    <div>
    <a-switch-field
      varName="authorize_endpoint_options.oidc_flow.implicit.enabled"
      varLabel="Implicit Flow"
      :varRequired="true"
      :varInitial="data.authorize_endpoint_options.oidc_flow.implicit.enabled"
      :formLayout="formLayout"
      :size="size"
      :disabled="false"
      description="All tokens are returned from the Authorization Endpoint; the Token Endpoint is not used. Not recommended."
    />
    <a-switch-field
      varName="authorize_endpoint_options.oidc_flow.authorization_code.enabled"
      varLabel="Authorization Code Flow"
      :varRequired="true"
      :varInitial="data.authorize_endpoint_options.oidc_flow.authorization_code.enabled"
      :formLayout="formLayout"
      :size="size"
      :disabled="false"
      description="All tokens returned from the Token Endpoint using an authorization code obtained from Authorization Endpoint."
    />
    <a-switch-field
      varName="authorize_endpoint_options.oidc_flow.hybrid.enabled"
      varLabel="Hybrid Flow"
      :varRequired="true"
      :varInitial="data.authorize_endpoint_options.oidc_flow.hybrid.enabled"
      :formLayout="formLayout"
      :size="size"
      :disabled="false"
      description="Some tokens are returned from the Authorization Endpoint and others are returned from the Token Endpoint."
    />
    </div>
</template>

<script>
export default {
  props: {
    formLayout: String,
    size: String,
    data: Object
  }
}
</script>